export const MANAGER_NAV_ITEMS = [
  { key: "studio-packages", label: "Studio Packages", icon: "📸" },
  { key: "wedding-packages", label: "Wedding Packages", icon: "💍" },
  { key: "studio-rentals", label: "Studio Rentals", icon: "🏢" },
  { key: "shop-products", label: "Shop Items", icon: "🛒" },
  { key: "shop-categories", label: "Shop Categories", icon: "📂" },
  { key: "shop-orders", label: "New Orders", icon: "📦" },
  { key: "completed-shop-orders", label: "Completed Orders", icon: "✅" },
  { key: "studio-bookings", label: "Studio Bookings", icon: "📅" },
  { key: "wedding-bookings", label: "Wedding Bookings", icon: "📅" },
  { key: "studio-rental-bookings", label: "Studio Rental Bookings", icon: "📅" },
  { key: "reviews", label: "Customer Reviews", icon: "⭐" },
];